/* Aasraa product video popup v2. Works with the original product form. */
(() => {
  const SELECTOR = '.aasraa-guides[data-aasraa-guides]';
  function init(root) {
    if (root.dataset.aasraaGuideReady === '1') return;
    const configNode = root.parentElement?.querySelector('[data-aasraa-guide-config]') || root.closest('.api-panel')?.querySelector('[data-aasraa-guide-config]');
    const modal = root.parentElement?.querySelector('[data-aasraa-guide-modal]') || root.closest('.api-panel')?.querySelector('[data-aasraa-guide-modal]');
    if (!configNode || !modal) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    root.dataset.aasraaGuideReady = '1';
    // Critical: move dialog outside theme sticky/transform/stacking contexts.
    // This makes the popup sit above the product sidebar and sticky cart buttons.
    document.body.appendChild(modal);
    const video = modal.querySelector('[data-guide-player]');
    const variantSelect = modal.querySelector('[data-guide-variant]');
    const price = modal.querySelector('[data-guide-price]');
    const productImage = modal.querySelector('.aasraa-guide-product-image');
    const compare = modal.querySelector('[data-guide-compare]');
    const availability = modal.querySelector('[data-guide-availability]');
    const add = modal.querySelector('[data-guide-add]');
    const addLabel = modal.querySelector('[data-guide-add-label]');
    const feedback = modal.querySelector('[data-guide-feedback]');
    const mute = modal.querySelector('[data-guide-mute]');
    const muteLabel = modal.querySelector('[data-guide-mute-label]');
    const fullscreen = modal.querySelector('[data-guide-fullscreen]');
    const variants = config.variants || [];
    let activeVariantId = String(config.initialVariantId);
    let opener = null;
    let originalOverflow = '';

    function getVariant() { return variants.find(v => String(v.id) === activeVariantId); }
    function money(cents) {
      const format = String(config.moneyFormat || '₹{{amount}}');
      const amount = Number(cents || 0) / 100;
      const decimals = format.includes('no_decimals') ? 0 : 2;
      const formatted = amount.toLocaleString('en-IN', {minimumFractionDigits:decimals,maximumFractionDigits:decimals});
      return (format.includes('₹') ? '₹' : format.includes('$') ? '$' : '₹') + formatted;
    }
    function renderVariant() {
      const v = getVariant();
      if (!v) { add.disabled = true; feedback.textContent = 'Please select a valid variant.'; return; }
      price.textContent = money(v.price);
      if (productImage) {
        // Shopify's product JSON exposes variant.featured_image.src (when assigned).
        // Otherwise retain the product's original featured image.
        const raw = config.variantImages?.[String(v.id)] || v.featured_image?.src || v.featured_image?.url || v.featured_media?.preview_image?.src || config.defaultImage || '';
        if (raw) {
          const next = new URL(raw, window.location.href);
          next.searchParams.set('width', '160');
          if (productImage.src !== next.href) productImage.src = next.href;
          productImage.alt = v.featured_image?.alt || (config.productTitle + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : ''));
        }
      }
      const sale = Number(v.compare_at_price) > Number(v.price);
      compare.hidden = !sale;
      if (sale) compare.textContent = money(v.compare_at_price);
      availability.textContent = v.available ? 'Available' : 'Currently unavailable';
      add.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (variantSelect) variantSelect.value = String(v.id);
    }
    function productForms() {
      return [...document.querySelectorAll('form[action*="/cart/add"]')].filter(form => !form.closest('.aasraa-guide-modal,.quick-add,.quick-add-modal,.cart-drawer,.sticky-cart'));
    }
    function formVariant(form) {
      return form.querySelector('[name="id"]')?.value || '';
    }
    function findForm() {
      const forms = productForms();
      // Prefer form with selected variant from THIS product.
      const exact = forms.find(form => variants.some(v => String(v.id) === String(formVariant(form))));
      if (exact) return exact;
      // A form whose action or id references this product, when the variant field is populated later.
      return forms.find(form => form.id?.includes(String(config.productId)) || form.dataset.productId === String(config.productId)) || null;
    }
    function syncFromForm() {
      const form = findForm();
      const selected = form && formVariant(form);
      if (selected && variants.some(v => String(v.id) === String(selected))) activeVariantId = String(selected);
      else {
        const urlId = new URLSearchParams(location.search).get('variant');
        if (urlId && variants.some(v => String(v.id) === urlId)) activeVariantId = urlId;
      }
      renderVariant();
    }
    function close() {
      if (modal.hidden) return;
      video.pause(); video.removeAttribute('src'); video.load();
      if (document.fullscreenElement && modal.contains(document.fullscreenElement)) document.exitFullscreen().catch(() => {});
      modal.hidden = true;
      document.body.style.overflow = originalOverflow;
      if (opener?.isConnected) opener.focus();
    }
    function open(which, button) {
      const src = config.videos?.[which];
      if (!src) return;
      opener = button;
      syncFromForm();
      modal.querySelector('[data-guide-title]').textContent = which === 'assembly' ? 'How to Assemble' : 'How to Use';
      const subtitle = modal.querySelector('[data-guide-subtitle]');
      if (subtitle) subtitle.textContent = which === 'assembly'
        ? 'Follow the assembly steps for this product.'
        : 'Learn the controls and everyday operation.';
      
video.pause();
video.muted = true;
video.defaultMuted = true;
video.autoplay = true;
video.playsInline = true;

video.setAttribute('autoplay', '');
video.setAttribute('muted', '');
video.setAttribute('playsinline', '');
video.setAttribute('webkit-playsinline', '');

video.src = src;
video.load();

muteLabel.textContent = 'Unmute';
mute.setAttribute('aria-label', 'Unmute video');

feedback.textContent = '';
originalOverflow = document.body.style.overflow;
document.body.style.overflow = 'hidden';
modal.hidden = false;

modal.querySelector('[data-guide-close]').focus();

// Start playback after the popup becomes visible.
const playPromise = video.play();

if (playPromise && typeof playPromise.catch === 'function') {
  playPromise.catch(error => {
    if (error.name !== 'AbortError') {
      console.warn('Aasraa: Video autoplay was blocked', error);
      feedback.textContent = 'Tap play to start the video.';
    }
  });
}

    }
    root.querySelectorAll('[data-guide-open]').forEach(btn => btn.addEventListener('click', () => open(btn.dataset.guideOpen,btn)));
    // The whole guide card is clickable, while retaining its real button for accessibility.
    root.querySelectorAll('[data-guide-card]').forEach(card => {
      const launch = card.querySelector('[data-guide-open]');
      if (!launch) return;
      card.addEventListener('click', event => {
        if (event.target.closest('button,a,input,select')) return;
        launch.click();
      });
      card.addEventListener('keydown', event => {
        if (event.target !== card || !['Enter',' '].includes(event.key)) return;
        event.preventDefault(); launch.click();
      });
    });
    modal.querySelectorAll('[data-guide-close]').forEach(btn => btn.addEventListener('click',close));
    document.addEventListener('keydown', event => {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'Tab') {
        const controls = [...modal.querySelectorAll('button:not([disabled]),select:not([disabled]),video[controls]')].filter(el => el.getClientRects().length);
        if (!controls.length) return;
        if (event.shiftKey && document.activeElement === controls[0]) { event.preventDefault(); controls.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === controls.at(-1)) { event.preventDefault(); controls[0].focus(); }
      }
    });
    mute.addEventListener('click', () => {
      video.muted = !video.muted;
      muteLabel.textContent = video.muted ? 'Unmute' : 'Mute';
      mute.setAttribute('aria-label',video.muted ? 'Unmute video' : 'Mute video');
    });
    fullscreen.addEventListener('click', async () => {
      try {
        if (document.fullscreenElement) await document.exitFullscreen();
        else if (video.requestFullscreen) await video.requestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
        else feedback.textContent = 'Fullscreen is not supported on this device.';
      } catch (_) { feedback.textContent = 'Fullscreen is not available on this device.'; }
    });
    if (variantSelect) variantSelect.addEventListener('change', () => {
      activeVariantId = variantSelect.value;
      renderVariant();
    });
    add.addEventListener('click', async () => {
      if (add.disabled) return;
      feedback.textContent = '';
      const v = getVariant();
      if (!v || !v.available) return;
      // The original theme form may contain third-party required-option validation,
      // even on a product with only its default variant. Use the selected Shopify
      // variant ID directly so the video popup cannot trigger an unrelated form.
      add.disabled = true;
      addLabel.textContent = 'Adding to Cart…';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          credentials: 'same-origin',
          body: JSON.stringify({items: [{id: Number(v.id), quantity: 1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        // Only open the drawer AFTER Shopify confirms the item was added.
        // Fetch the updated cart and fresh HTML sections, not a speculative event.
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Cart could not be verified. Please refresh and check your cart.');
        const cart = await cartResponse.json();
        const found = cart.items.some(item => String(item.variant_id) === String(v.id));
        if (!found) throw new Error('The item was not found in the cart. Please try again.');

        const drawer = document.querySelector('cart-drawer');
        let refreshed = false;
        // Shopify Dawn-style cart drawer exposes renderContents(), which
        // requires the add response to include rendered sections.
        if (drawer && typeof drawer.renderContents === 'function') {
          try {
            const sectionIds = typeof drawer.getSectionsToRender === 'function'
              ? drawer.getSectionsToRender().map(s => s.id)
              : ['cart-drawer', 'cart-icon-bubble'];
            const sectionResponse = await fetch(root + '?sections=' + encodeURIComponent(sectionIds.join(',')), { credentials: 'same-origin', cache: 'no-store' });
            if (sectionResponse.ok) {
              const sections = await sectionResponse.json();
              drawer.renderContents({ id: result.items?.[0]?.id || v.id, sections });
              refreshed = true;
            }
          } catch (error) { console.warn('Aasraa: drawer renderContents unavailable', error); }
        }
        if (!refreshed) {
          // Update standard Shopify cart sections in place, including the
          // header badge, before opening the existing drawer.
          try {
            const sectionResponse = await fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' });
            if (sectionResponse.ok) {
              const sections = await sectionResponse.json();
              for (const [sectionId, selector] of [['cart-drawer','cart-drawer'], ['cart-icon-bubble','#cart-icon-bubble']]) {
                if (!sections[sectionId]) continue;
                const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
                const incoming = doc.querySelector(selector);
                const current = document.querySelector(selector);
                if (incoming && current && sectionId === 'cart-icon-bubble') current.innerHTML = incoming.innerHTML;
                else if (incoming && current && sectionId === 'cart-drawer') {
                  const incomingInner = incoming.querySelector('.drawer__inner');
                  const currentInner = current.querySelector('.drawer__inner');
                  if (incomingInner && currentInner) currentInner.innerHTML = incomingInner.innerHTML;
                }
              }
              refreshed = true;
            }
          } catch (error) { console.warn('Aasraa: cart section refresh unavailable', error); }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, source: 'aasraa-guide-popup' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, source: 'aasraa-guide-popup' } }));
        close();
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          const trigger = document.querySelector('[data-cart-drawer-toggle], [data-cart-toggle], [data-drawer-trigger="cart"], [data-cart-trigger], .js-drawer-open-cart, .cart-drawer-toggle, .header__icon--cart, button[aria-controls="CartDrawer"], a[aria-controls="CartDrawer"], [aria-controls="cart-drawer"]');
          if (trigger) trigger.click();
          else feedback.textContent = 'Added to cart. Open the cart icon to view it.';
        }

      } catch (error) {
        feedback.textContent = error.message || 'Could not add to cart. Please try again.';
        add.disabled = false;
        addLabel.textContent = 'Add to Cart';
      }
    });
    renderVariant();
  }
  function boot() { document.querySelectorAll(SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
